export { default } from './Renegociacao25Banner';
